import { createI18n } from 'vue-i18n';
import ja from './locale/ja.json';
import en from './locale/en.json';

const userLang = window.navigator.language;
let userLocale;

switch(userLang) {
// English
// case 'en':
// case 'en-US':
//     userLocale = 'en';
//     break;

// Japanese
case 'ja':
  userLocale = 'ja';
  break;

default:
  userLocale = 'ja';
  break;
}

const i18n = createI18n({
  locale: userLocale,
  messages: {
      ja: ja,
      en: en,
  }
})

export default i18n;